<template>
  <!-- タブボタン部分 -->
  <ul class="nav nav-tabs">
    <li class="nav-item" v-if="loginUserInfo.auth_req_estimate">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'estimate' }"
        @click.prevent="
          submitAsteria(
            'RequestEstimate',
            'loadHTML_forRequestEstimate',
            {},
            '',
            '/request/estimate.html'
          )
        "
        >見積依頼</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_req_sample">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'sample' }"
        @click.prevent="
          submitAsteria(
            'RequestSample',
            'loadHTML_forRequestSample',
            {},
            '',
            '/request/sample.html'
          )
        "
        >サンプル依頼</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_req_catalogue">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'catalog' }"
        @click.prevent="
          submitAsteria(
            'RequestCatalog',
            'loadHTML_forRequestCatalog',
            {},
            '',
            '/request/catalogue.html'
          )
        "
        >カタログ依頼</a
      >
    </li>
    <li class="nav-item" v-if="loginUserInfo.auth_req_envdocument">
      <a
        href="#"
        class="nav-link"
        :class="{ active: active === 'environment' }"
        @click.prevent="
          submitAsteria(
            'RequestEnvironment',
            'loadHTML_forRequestEnvironment',
            {},
            '',
            '/request/environment.html'
          )
        "
        >環境書類</a
      >
    </li>
    <li class="nav-item" v-if="hasRequestState">
      <a
        href="#"
        @click.prevent="linkToRequestState"
        class="nav-link"
        :class="{ active: active === 'request_status' }"
        >依頼状況</a
      >
    </li>
  </ul>
</template>

<script>
import { store as loginUserStore } from "../../store/LoginUser";

export default {
  props: {
    active: { props: String, required: true }
  },

  computed: {
    loginUserInfo() {
      return loginUserStore.info;
    },
    hasRequestState() {
      return (
        this.loginUserInfo.auth_ref_estimate ||
        this.loginUserInfo.auth_ref_samplecatalogue ||
        this.loginUserInfo.auth_ref_envdocument
      );
    }
  },
  methods: {
    linkToRequestState() {
      // 見積依頼状況
      if (this.loginUserInfo.auth_ref_estimate) {
        return this.submitAsteria(
          "RequestStateEstimate",
          "loadHTML_forRequestStateEstimate",
          {},
          "",
          "/requeststate/estimate.html"
        );
      }

      // サンプルカタログ依頼状況
      if (this.loginUserInfo.auth_ref_samplecatalogue) {
        return this.submitAsteria(
          "RequestStateSampleCatalogue",
          "loadHTML_forRequestStateSampleCatalogue",
          {},
          "",
          "/requeststate/samplecatalogue.html"
        );
      }

      // 環境依頼状況
      if (this.loginUserInfo.auth_ref_envdocument) {
        return this.submitAsteria(
          "RequestStateEnvironment",
          "loadHTML_forRequestStateEnvironment",
          {},
          "",
          "/requeststate/environment.html"
        );
      }
    }
  }
};
</script>
